var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderIconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "card-icon/app copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-Credit-Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00:-Table-of-Contents",
    transform: "translate(-728.000000, -433.000000)",
    fill: "#A1A5B3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(698.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/invoice-due",
    transform: "translate(25.624344, 95.642632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Calendar_1452532_000000",
    transform: "translate(5.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.018115942,5.27010309 L0.018115942,17.6742268 C0.018115942,18.9484536 0.93115942,19.9876289 2.05072464,19.9876289 L12.9492754,19.9876289 C14.0688406,19.9876289 14.9818841,18.9484536 14.9818841,17.6742268 L14.9818841,5.27010309 C14.9818841,4.01237113 14.0978261,2.99381443 13,2.96494845 L13,5.2371134 C13,6.30515464 12.2391304,7.17113402 11.3007246,7.17113402 C10.3623188,7.17113402 9.60144928,6.30515464 9.60144928,5.2371134 L9.60144928,2.96082474 L5.40217391,2.96082474 L5.40217391,5.2371134 C5.40217391,6.30515464 4.64130435,7.17113402 3.70289855,7.17113402 C2.76449275,7.17113402 2.00362319,6.30515464 2.00362319,5.2371134 L2.00362319,2.96907216 C0.902173913,2.99381443 0.018115942,4.01237113 0.018115942,5.27010309 Z M13.6231884,10.3340206 L13.6231884,17.6742268 C13.6231884,18.0948454 13.3224638,18.4371134 12.9492754,18.4371134 L2.05072464,18.4371134 C1.68115942,18.4371134 1.37681159,18.0948454 1.37681159,17.6742268 L1.37681159,10.3340206 L13.6231884,10.3340206 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38405797,5.23298969 L4.38405797,0.791752577 C4.38405797,0.362886598 4.07971014,0.0164948454 3.70289855,0.0164948454 C3.32608696,0.0164948454 3.02173913,0.362886598 3.02173913,0.791752577 L3.02173913,5.23298969 C3.02173913,5.66185567 3.32608696,6.00824742 3.70289855,6.00824742 C4.07971014,6.00824742 4.38405797,5.66185567 4.38405797,5.23298969 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9782609,5.23298969 L11.9782609,0.791752577 C11.9782609,0.362886598 11.673913,0.0164948454 11.2971014,0.0164948454 C10.9202899,0.0164948454 10.615942,0.362886598 10.615942,0.791752577 L10.615942,5.23298969 C10.615942,5.66185567 10.9202899,6.00824742 11.2971014,6.00824742 C11.673913,6.00824742 11.9782609,5.66185567 11.9782609,5.23298969 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderIconDate);
export default __webpack_public_path__ + "static/media/table-header-icon-date.48606826dd6c91e8eb23ec8192a7b169.svg";
export { ForwardRef as ReactComponent };